import React from "react";

type ReportTypeOption = {
  label: string;
  value: string;
};

export const ESPECS_REPORT_TYPE_OPTIONS: ReportTypeOption[] = [
  {
    label: "New connection",
    value: "workload-allocation",
  },
  {
    label: "Change supply",
    value: "change-allocation",
  },
  {
    label: "Remove supply",
    value: "remove-allocation",
  },
  {
    label: "Messages",
    value: "message",
  },
  {
    label: "Close and transfer",
    value: "handover-allocation",
  },
  {
    label: "Concession",
    value: "concession-allocation",
  },
];

export interface IReportSection {
  setUnableToDownload: (value: React.SetStateAction<boolean>) => void;
}
